import { render, staticRenderFns } from "./liveModel.vue?vue&type=template&id=0bc55f23&scoped=true&"
import script from "./liveModel.vue?vue&type=script&lang=js&"
export * from "./liveModel.vue?vue&type=script&lang=js&"
import style0 from "./liveModel.vue?vue&type=style&index=0&id=0bc55f23&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc55f23",
  null
  
)

export default component.exports